
module.exports = [
  'M15 0 H17 L32 29 L31 30 L1 30 L0 29 z M19 8 L13 8 L14 20 L18 20 z M16 22 A3 3 0 0 0 16 28 A3 3 0 0 0 16 22'
].join(' ')




/*****************
 ** WEBPACK FOOTER
 ** ./~/geomicons-open/src/paths/warning.js
 ** module id = 243
 ** module chunks = 0
 **/